const $ = window.$;


export default class Model {
  constructor() {
    this.state = {
      scroll: 0, // 現在のスクロール量
      headerPos: 0, // ヘッダーの位置
      isHeaderFixed: false, // ヘッダー固定かどうか
      isStreamMore: false, // moreを押したかどうか
      streamType: 'all', // PhotoStreamのタイプ
      streamData: [ // 各PhotoStreamのmodel
      // person icon_stream_01
      //climate icon_stream_02
      //food icon_stream_03
        { type: 'person', img: 'photo_stream_item_01.png', icon: 'icon_stream_01.png', txt: 'The sound of heartfelt laughter bubbles up wherever people gather to enjoy good food and shochu.' },
        { type: 'person', img: 'photo_stream_item_02.png', icon: 'icon_stream_01.png', txt: 'People naturally come together wherever seasonal cuisine and shochu can be found.' },
        { type: 'person', img: 'photo_stream_item_03.png', icon: 'icon_stream_01.png', txt: 'Ingredients determine what makes a fine-tasting shochu. We use only sweet potatoes from Southern Kyushu.' },
        { type: 'person', img: 'photo_stream_item_04.png', icon: 'icon_stream_01.png', txt: 'Honkaku Shochu is an integral part of Kyushu\'s rich food culture.' },
        { type: 'person', img: 'photo_stream_item_05.png', icon: 'icon_stream_01.png', txt: 'The quality of a fine-tasting shochu is ultimately determined by the customer who drinks it.' },
        { type: 'person', img: 'photo_stream_item_06.png', icon: 'icon_stream_01.png', txt: 'Identifying the unique sounds and smells of the ingredients as they ferment is part of watching over the shochu-making process. ' },
        { type: 'person', img: 'photo_stream_item_07.png', icon: 'icon_stream_01.png', txt: 'Through our recycling and power businesses and our environmental protection efforts, our goal is to create a recycling-oriented business in harmony with nature.' },
        { type: 'person', img: 'photo_stream_item_08.png', icon: 'icon_stream_01.png', txt: 'The sweet potatoes used in our shochu are nurtured at the hands of nearly 2,000 local producers spread throughout Southern Kyushu.' },
        { type: 'person', img: 'photo_stream_item_09.png', icon: 'icon_stream_01.png', txt: 'Our strict quality control extends to our bottling and shipping operations.' },
        { type: 'person', img: 'photo_stream_item_10.png', icon: 'icon_stream_01.png', txt: 'Each type of unrefined shochu has its own characteristics. Multiple types of unrefined shochu are matched, then blended together to produce a consistent flavor.' },
        { type: 'person', img: 'photo_stream_item_11.png', icon: 'icon_stream_01.png', txt: 'Even as machines have become more capable, our quality continues to be determined by human eyes and hands.' },
        { type: 'climate', img: 'photo_stream_item_12.png', icon: 'icon_stream_02.png', txt: 'The sun, and the land. sweet potatoes are nurtured by nature\'s bounty.' },
        { type: 'climate', img: 'photo_stream_item_13.png', icon: 'icon_stream_02.png', txt: 'We continue to focus on quality, because we believe that "spurring passion from quality." ' },
        { type: 'climate', img: 'photo_stream_item_14.png', icon: 'icon_stream_02.png', txt: 'Alcohol left as offerings at Kirishima Shrine exude a rich fragrance.' },
        { type: 'climate', img: 'photo_stream_item_15.png', icon: 'icon_stream_02.png', txt: 'As the moon rises in the night sky, people gather, sweet potatoes shochu in hand, to relax after a long day.' },
        { type: 'climate', img: 'photo_stream_item_16.png', icon: 'icon_stream_02.png', txt: 'The appearance of the Kirishima Range, which we consider the mother of Kirishima Shuzo, is ever-changing.' },
        { type: 'climate', img: 'photo_stream_item_17.png', icon: 'icon_stream_02.png', txt: 'The Miyakonojo Basin has a unique <i>koji</i> (malt) culture, nurtured by the laurel forests of Asia.' },
        { type: 'climate', img: 'photo_stream_item_18.png', icon: 'icon_stream_02.png', txt: 'Our pursuit of the finest-tasting Honkaku Shochu eventually led to the Kogane-Sengan sweet potatoes.' },
        { type: 'climate', img: 'photo_stream_item_19.png', icon: 'icon_stream_02.png', txt: 'Clear, cold Kirishima Rekka-sui is the key to the quality of our Honkaku Shochu.' },
        { type: 'climate', img: 'photo_stream_item_20.png', icon: 'icon_stream_02.png', txt: 'The Kirishima (literally "mist islands") mountain range got its name because its peaks appear to be floating in the mist.' },
        { type: 'climate', img: 'photo_stream_item_21.png', icon: 'icon_stream_02.png', txt: 'The Kirishima Shochu Shrine is said to bring prosperity in business.' },
        { type: 'climate', img: 'photo_stream_item_22.png', icon: 'icon_stream_02.png', txt: 'Our shochu factories represents an integration of traditional techniques refined over time with cutting-edge equipment.' },
        { type: 'climate', img: 'photo_stream_item_23.png', icon: 'icon_stream_02.png', txt: 'Our employees welcome customers to the Kirishima Festival, held twice a year, to express their gratitude.' },
        { type: 'food', img: 'photo_stream_item_24.png', icon: 'icon_stream_03.png', txt: 'Decorated with an image of the moon over a rice field, <i>suko</i> sushi recalls the picturesque beauty of a rural landscape. ' },
        { type: 'food', img: 'photo_stream_item_25.png', icon: 'icon_stream_03.png', txt: 'Seasoned <i>ryukyu</i> style raw fish is infused with the richness of soy sauce, for a flavor different from traditional <i>sashimi</i>. ' },
        { type: 'food', img: 'photo_stream_item_26.png', icon: 'icon_stream_03.png', txt: '<i>Kurobuta</i>(Berkshire pig) shabu-shabu brings out the rich flavor of this high quality pork. ' },
        { type: 'food', img: 'photo_stream_item_27.png', icon: 'icon_stream_03.png', txt: 'Packed with nourishment, <i>chanpon</i> features firm noodles in a broth made from chicken and pork bones. ' },
        { type: 'food', img: 'photo_stream_item_28.png', icon: 'icon_stream_03.png', txt: '<i>Basashi</i>, Raw sliced horsemeat has a uniquely appealing umami and texture.' },
        { type: 'food', img: 'photo_stream_item_29.png', icon: 'icon_stream_03.png', txt: 'Bitter gourd and a flavorful broth come together perfectly in <i>goya champuru</i>, a traditional stir-fry.' },
        { type: 'food', img: 'photo_stream_item_30.png', icon: 'icon_stream_03.png', txt: 'The sweetness and firm texture of sliced, raw squid can only be enjoyed when the squid is freshly prepared.' },
        { type: 'food', img: 'photo_stream_item_31.png', icon: 'icon_stream_03.png', txt: '<i>Gane</i> is a rustic homemade dish of sweet potatoes, thinly sliced and deep fried.' },
        { type: 'food', img: 'photo_stream_item_32.png', icon: 'icon_stream_03.png', txt: 'Grilling over charcoal brings out all the flavor of simply seasoned shiitake mushrooms.' },
        { type: 'food', img: 'photo_stream_item_33.png', icon: 'icon_stream_03.png', txt: 'Enjoyed with plenty of vegetables, <i>motsu</i> (offal) hot pot exudes richness and deep flavor.' },
        { type: 'food', img: 'photo_stream_item_34.png', icon: 'icon_stream_03.png', txt: 'Crisp lotus root stuffed with  Japanese mustard delivers a kick of spice, softened by the sweetness of miso. ' },
        { type: 'food', img: 'photo_stream_item_35.png', icon: 'icon_stream_03.png', txt: 'Aromatic smoke brings out the richness and firm texture of charcoal-grilled free range chicken.' },
        { type: 'food', img: 'photo_stream_item_36.png', icon: 'icon_stream_03.png', txt: 'Sweet, juicy grilled eggplant has an appealingly silky texture. ' },
        { type: 'food', img: 'photo_stream_item_37.png', icon: 'icon_stream_03.png', txt: 'Fresh, lightly seared bonito is enhanced by a delicately sweet, fragrant soy sauce.' },
        { type: 'food', img: 'photo_stream_item_38.png', icon: 'icon_stream_03.png', txt: 'Named No. 1 in Japan among Wagyu beef brands, Miyazaki Beef stands out  for its firm yet tender texture.' },
      ],
      shuffleStreamArray: [], // シャッフル済みPhotoStream格納用
      streamTimer: [], // PhotoStreamのsetTimeout格納用
    }

    this.setInitialState();
  }



// -----------------------------------------------------------------
// state 初期化
// @method setInitialState
// -----------------------------------------------------------------
  setInitialState() {
    this.state.headerPos = $('#js-header').offset().top;
    this.state.shuffleStreamArray = this.shuffleArray(this.state.streamData);
  }



// -----------------------------------------------------------------
// viewのイベントによってstate変更
// @method setState
// -----------------------------------------------------------------
  setState(type, data) {
    switch(type) {
      case 'scroll':
        this.state.scroll = $(window).scrollTop();
        this.state.isHeaderFixed = this.state.scroll > this.state.headerPos ? true : false;
        break;
      case 'stream':
        this.state.streamType = data
        break;
      case 'streamTimer':
        this.state.streamTimer.push(data)
        break;
      case 'streamMore':
        this.state.isStreamMore = true;
        break;
    }

    this.divideProcess(type);
  }



// -----------------------------------------------------------------
//
// @method shuffleArray
// -----------------------------------------------------------------
  shuffleArray(array) {
    var n = array.length, t, i;

    while (n) {
      i = Math.floor(Math.random() * n--);
      t = array[n];
      array[n] = array[i];
      array[i] = t;
    }

    return array;
  }




// -----------------------------------------------------------------
// viewのイベントによって処理実行
// @method divideProcess
// -----------------------------------------------------------------
  divideProcess(type) {
    switch(type) {
      case 'scroll':
        this.emit(type);
        break;
      case 'stream':
        this.emit(type);
        break;
    }
  }



// -----------------------------------------------------------------
// viewにイベント通知
// @method emit
// -----------------------------------------------------------------
  emit(type) {
    switch(type) {
      case 'scroll':
        $('#js-topPage').trigger('toggleHeader');
        break;
      case 'stream':
        $('#js-topPage').trigger('stream');
        break;
    }
  }

}

$(function(){

  $('.lang-list').on({
    'mouseenter':function(){
      $('.lang-menu').fadeIn();
    },
    'mouseleave':function(){
      $('.lang-menu').fadeOut();
    }
  });

});



/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/model/top.js
 **/